import React from 'react';
import {
  Box,
  Typography,
  Divider
} from '@mui/material';
import { Assignment as AssignmentIcon } from '@mui/icons-material';

const ResumenGeneral = ({ totalPedidos, pedidosEntregados }) => {
  return (
    <Box sx={{ mb: 2 }}>
      {/* Título principal */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <AssignmentIcon 
          color="primary" 
          sx={{ mr: 1, fontSize: 22 }} 
        />
        <Typography 
          variant="h6" 
          fontWeight="bold"
          color="primary"
          sx={{ fontSize: '1.1rem' }}
        >
          Resumen de Entregas
        </Typography>
      </Box>
      
      {/* Subtítulo con información */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mr: 2 }}>
          Total de pedidos encontrados: 
          <Box component="span" fontWeight="bold" sx={{ ml: 0.5, color: 'primary.main' }}>
            {totalPedidos}
          </Box>
        </Typography>
      </Box>
      
      <Divider sx={{ mb: 2 }} />
      
      
    </Box>
  );
};

export default ResumenGeneral;